import { omit } from 'lodash';

// The API returns a location object which contains __typename and status meta
// properties. We should strip these values before storing the location.
const getCleanLocation = locationResponse =>
  omit(locationResponse, ['__typename', 'status']);

export default getCleanLocation;
